import { withHandlers } from 'recompose'
import DropdownInput from './DropdownInput'

export default withHandlers({
  handleToggle: ({ active, onBlur, onFocus }) => () =>
    active ?
      onBlur() :
      onFocus()
})(DropdownInput)
